import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../../../enums/queryKeys";
import { getBillingOverview } from "../billing.api";

export const useBillingOverview = () =>
  useQuery({
    queryKey: QueryKeys.BILLING_OVERVIEW,
    queryFn: getBillingOverview,
    staleTime: 60 * 1000,
  });
